export const ADD_ITEM = "ADD_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const REMOVE_ITEMS = "REMOVE_ITEMS";

export const MODAL_OPEN = "MODAL_OPEN";
export const MODAL_CLOSE = "MODAL_CLOSE";

export const TAX_GET = "TAX_GET";



// WEBPACK FOOTER //
// ./src/actions/types.js